import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Subject } from 'rxjs';
import { UploadFile } from 'src/app/models/uploadfile.model';
import { CaseService } from 'src/app/services/case.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UploadService } from 'src/app/services/upload.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { SnackbarMessageComponent } from '../snackbar/snackbar-message/snackbar-message.component';
import { LetterModel } from 'src/app/models/letter.model';
import { LetterAttachmentModel } from 'src/app/models/letter-attachment.model';
import { CaseModel } from 'src/app/models/case.model';
import { CaseEventModel } from 'src/app/models/case-event.model';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-case-events-list',
  templateUrl: './case-events-list.component.html',
  styleUrls: ['./case-events-list.component.scss']
})
export class CaseEventsListComponent implements OnInit, OnDestroy, AfterViewInit
{

  private componentDestroyed = new Subject();

  displayedColumns = ['EventDate', 'UploadedBy', 'Name'];
  dataSource: MatTableDataSource<CaseEventModel> = new MatTableDataSource<CaseEventModel>();
  currentCase!: CaseModel;

  @ViewChildren("fileUpload")
  public FileuploadComponents!: QueryList<FileUploadComponent>

  private fileUploadComponent!: FileUploadComponent;

  get files(): UploadFile[]
  {
    if (this.fileUploadComponent)
    {
      return this.fileUploadComponent.files;
    } else
    {
      return [];
    }
  }

  docListVisibleArr!: boolean[];

  showSendLetterComponent: boolean = false;
  isUploading: boolean = false;

  messageBody: string = '';

  constructor(
    private spinnerService: SpinnerService,
    private caseService: CaseService,
    private uploadService: UploadService,
    private snackbar: MatSnackBar)
  {

    this.uploadService.isUploading
      .subscribe(
        (val: boolean) =>
        {
          this.isUploading = val;
        }
      );

    this.caseService.currentCase
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (value: CaseModel | null) =>
        {
          if (value !== null)
          {
            this.currentCase = value;
            this.dataSource.data = this.currentCase.Events;
          }
        }
      )
  }

  ngOnDestroy(): void
  {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  ngAfterViewInit(): void
  {
    this.FileuploadComponents.changes.subscribe(
      (comps: QueryList<FileUploadComponent>) =>
      {
        this.fileUploadComponent = comps.first;
      });
  }

  ngOnInit(): void
  {

  }

  onFileDropped(files: FileList)
  {

    if (this.isUploading)
    {
      return;
    }

    if (files.length > 0)
    {
      this.uploadService.addFiles(files);
    }
  }

  toggleSendLetter()
  {
    this.showSendLetterComponent = !this.showSendLetterComponent;
  }

  openAllByAttachmentGroup(attachmentGroupId: string, caseUid: string)
  {
    this.spinnerService.show("Henter vedlegg...");
    this.caseService.openAllByEventId(attachmentGroupId, caseUid);
  }

  submit(): void
  {

    if (this.files.length > 0 || this.messageBody !== '')
    {

      this.spinnerService.show("Sender brev");

      var letterFiles: LetterAttachmentModel[] = [];
      var files = this.files.map(x => x.deleteKey) //.slice();
      if (files)
      {
        letterFiles = files as LetterAttachmentModel[];
      }

      let letter: LetterModel = {
        CaseUid: this.currentCase.CaseUid,
        Content: this.messageBody,
        Files: letterFiles
      }

      this.caseService.sendLetter(letter)
        .subscribe(
          {
            next: (response: any) =>
            {
              this.caseService.loadCase(this.currentCase.CaseUid);

              if (this.files.length > 0)
              {
                this.fileUploadComponent.clearFiles(false, false);
              }

              this.spinnerService.hide();
              this.snackbar.openFromComponent(SnackbarMessageComponent, { data: { message: 'Brev sendt', type: 'info' } });
            },
            error: (error: HttpErrorResponse) =>
            {
              console.log(error);
              this.snackbar.openFromComponent(SnackbarMessageComponent, { data: { message: error.error, type: 'error' } });
              this.spinnerService.hide();
            },
            complete: () =>
            {
              console.log('Finish send letter');
              this.closeSendLetterComponent();
            }
          }
        );
    }
  }

  closeSendLetterComponent(): void
  {
    this.messageBody = '';
    this.fileUploadComponent.clearFiles(true, false);
    this.showSendLetterComponent = false;
  }



}
